module.exports = __webpack_public_path__ + "img/pink-3.9929a70b.svg";